/* src/app/system-utils/prompt-save-dialog-multiple/prompt-save-dialog-multiple.component.scss */
.content {
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
}
.fields-container {
  padding-left: 10px;
  padding-right: 10px;
  padding-bottom: 5px;
}
.fields {
  height: 100%;
  width: 100%;
}
.field-error {
  color: var(--tem-danger);
  font-size: var(--tem-fs-sm);
  margin-top: var(--tem-space-1);
}
.view-component-title {
  padding: var(--tem-space-2) var(--tem-space-3);
  font-weight: 600;
  color: var(--tem-ink);
  border-bottom: 1px solid var(--tem-border);
}
.options {
  display: flex;
  flex-direction: row;
  gap: 10px;
  padding: 10px;
}
/*# sourceMappingURL=prompt-save-dialog-multiple.component.css.map */
